import { Badge } from '@/components/ui/badge';
import { formatCents, cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface CategoryStatCardProps {
  icon: LucideIcon;
  label: string;
  count: number;
  amount: number;
  description: string;
  borderColor: string;
  iconColor: string;
}

export function CategoryStatCard({ 
  icon: Icon, 
  label, 
  count, 
  amount, 
  description,
  borderColor,
  iconColor 
}: CategoryStatCardProps) {
  return (
    <div className={cn("relative overflow-hidden rounded-lg bg-background shadow-sm border-l-4", borderColor)}>
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <Icon className={cn("h-5 w-5", iconColor)} />
            <h3 className="font-semibold text-sm">{label}</h3>
          </div>
          <Badge variant="secondary" className="text-xs">
            {count}
          </Badge>
        </div>
        <div className="space-y-1">
          <div className="text-2xl font-bold">{formatCents(amount)}</div>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
      </div>
    </div>
  );
}
